<ul>
    <ng-container *ngFor="let room of cancelPolicies; let i = index">
        <!-- Xử lý trường hợp chỉ có một chính sách -->
        <li *ngIf="cancelPolicies.length == 1">
             <!-- for 3rdpary cancel policy -->
             <ng-container *ngIf="room.from_day == 0 && room.to_day == 0; else otherDays">
                • {{ 'CANCELLATION_POLICIES.CANCELLATION_MADE_IN_CHECK_IN_DAY' | translate }}
            </ng-container>
            <ng-template #otherDays>
                • {{ 'CANCELLATION_POLICIES.CANCEL_ANYTIME' | translate }}
            </ng-template>
            <ng-container *ngIf="room.charge !== null">
                <ng-container [ngSwitch]="room.charge_type">
                    <!-- Trường hợp charge theo đêm đầu tiên -->
                    <span *ngSwitchCase="3">
                        {{ 'CANCELLATION_POLICIES.CHARGED_NIGHT' | translate: { chargeValue: room.charge, s: room.charge > 1 ? 's' : '' } }}
                    </span>
                    <!-- Trường hợp charge theo phần trăm -->
                    <span *ngSwitchCase="2">
                        {{ 'CANCELLATION_POLICIES.CHARGED_PERCENT' | translate: { chargeValue: room.charge } }}
                    </span>
                    <!-- Trường hợp charge theo số tiền -->
                    <span *ngSwitchCase="1">
                        {{ 'CANCELLATION_POLICIES.CHARGED_AMOUT' | translate }} 
                        <ng-container *ngIf="exchangeRate; else userCurrency">
                            {{ formatCurrency(room.charge, currency) }}
                        </ng-container>
                        <ng-template #userCurrency>
                            {{ room.charge | currencyConversion }}
                        </ng-template>
                    </span>
                    <!-- Trường hợp không tính phí -->
                    <span *ngSwitchCase="0">
                        {{ 'CANCELLATION_POLICIES.WONT_BE_CHARGED' | translate }}
                    </span>
                    <span *ngSwitchDefault></span>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="room.charge === null">
                {{ 'CANCELLATION_POLICIES.WONT_BE_CHARGED' | translate }}
            </ng-container>
        </li>

         <!-- Xử lý các chính sách hủy nhiều phần -->
         <li *ngIf="cancelPolicies.length > 1">

            <!-- The first policy -->
            <ng-container *ngIf="i === 0 && room.from_day === null">
                • {{ 'CANCELLATION_POLICIES.FIRST_CANCEL' | translate }} {{ getDateBefore(room.to_day, checkInDate) | dateFormat }} {{timeZone}}
            </ng-container>

            <!-- The mid policy -->
            <ng-container *ngIf="room.from_day > 0 && room.to_day > 0">
                • {{ 'CANCELLATION_POLICIES.MID_CANCEL' | translate }}
                {{ getDateBefore(room.from_day, checkInDate) | dateFormat }}
                {{ 'CANCELLATION_POLICIES.TO' | translate }}
                {{ getDateBefore(room.to_day, checkInDate) | dateFormat }} {{timeZone}}
            </ng-container>

            <!-- Last policy -->
            <ng-container *ngIf="room.from_day > 0 && (room.to_day == 0 || room.to_day == null)">
                • {{ 'CANCELLATION_POLICIES.LAST_CANCEL' | translate }} {{ getDateBefore(room.from_day, checkInDate) | dateFormat }} {{timeZone}}
            </ng-container>
            <!-- for 3rdpary cancel policy -->
            <ng-container *ngIf="room.from_day == 0 && room.to_day == 0">
                • {{ 'CANCELLATION_POLICIES.CANCELLATION_MADE_IN_CHECK_IN_DAY' | translate }}
            </ng-container>

            <!-- Suffix -->
            <ng-container *ngIf="room.charge == null || room.charge_type == 0">
                {{ 'CANCELLATION_POLICIES.WONT_BE_CHARGED' | translate }}
            </ng-container>
            <ng-container *ngIf="room.charge && room.charge_type == 3">
                {{ 'CANCELLATION_POLICIES.CHARGED_NIGHT' | translate : { chargeValue: room.charge, s: room.charge > 1 ? 's' : '' } }}
            </ng-container>
            <ng-container *ngIf="room.charge && room.charge_type == 2">
                {{ 'CANCELLATION_POLICIES.CHARGED_PERCENT' | translate : { chargeValue: room.charge } }}
            </ng-container>
            <ng-container *ngIf="room.charge && room.charge_type == 1">
                {{ 'CANCELLATION_POLICIES.CHARGED_AMOUT' | translate }} 
                <ng-container *ngIf="exchangeRate; else userCurrency">
                    {{ formatCurrency(room.charge, currency) }}
                </ng-container>
                <ng-template #userCurrency>
                    {{ room.charge | currencyConversion }}
                </ng-template>
            </ng-container>
        </li>
    </ng-container>
</ul>
